var Globals = (function() {
	'use strict';

	var CordovaFileCache = require('cordova-file-cache');
	var CordovaPromiseFS = require('cordova-promise-fs');
	var fs = new CordovaPromiseFS({ // An instance of CordovaPromiseFS is REQUIRED
			    persistent: true,
			    storageSize: 20 * 1024 * 1024,
			    concurrency: 3,
			    Promise: Promise
			});
	var cache =  new CordovaFileCache({
			    fs: fs,
			    mode: 'hash', // or 'hash', optional
			    localRoot: 'data' //optional
			    //serverRoot: 'http://yourserver.com/files/', // optional, required on 'mirror' mode
			    //cacheBuster: false  // optional
			});


	return {
		fs : fs,
		cache : cache
	}
}());

module.exports = Globals;